<div class="fixed bottom-4 right-4 z-50 cursor-move" *ngIf="isCallActive()" cdkDrag>
  <button
    (click)="toggleMinimize()"
    [tooltip]="isMinimized ? 'Maximize' : 'Minimize'"
    [placement]="'left'"
    class="flex items-center justify-center relative right-[10px] -top-[-10px] w-6 h-6 bg-foreground rounded-2xl border border-border">
    <tabler-icon
      name="{{ isMinimized ? 'maximize' : 'minimize' }}"
      class="!h-4 !w-4 text-background cursor-pointer"></tabler-icon>
  </button>
  <div
    *ngIf="!isMinimized"
    class="bg-foreground rounded-2xl shadow-lg p-6 min-w-[320px]">
    <!-- Call Status Header -->
    <div class="flex items-center justify-between mb-3">
      <div class="flex items-center gap-2">
        <div
          class="w-2 h-2 rounded-full"
          [class.bg-yellow-500]="
            callState.status === 'connecting' || callState.status === 'ringing'
          "
          [class.bg-green-500]="callState.status === 'connected'"
          [class.animate-pulse]="callState.status === 'ringing'"></div>
        <span class="text-sm font-medium text-background">
          {{ getStatusLabel() }}
        </span>
      </div>
      <span
        class="text-xs text-background font-mono"
        *ngIf="isCallConnected() && callState.duration">
        {{ formatDuration(callState.duration) }}
      </span>
    </div>

    <!-- Caller Information (shown when connected) -->
    <div *ngIf="isCallConnected() && callState.callerInfo" class="mb-3 pb-3">
      <div class="flex flex-col items-center gap-1">
        <!-- Avatar -->
        <app-avatar [key]="callState.callerInfo.name" class="w-20 h-20 mb-2">
        </app-avatar>
        <!-- Name -->
        <div *ngIf="callState.callerInfo.name" class="flex items-center gap-2">
          <tabler-icon
            name="user"
            class="!h-4 !w-4 text-background"></tabler-icon>
          <span class="text-sm font-medium text-background">{{
            callState.callerInfo.name
          }}</span>
        </div>
        <!-- Email -->
        <div *ngIf="callState.callerInfo.email" class="flex items-center gap-2">
          <tabler-icon
            name="mail"
            class="!h-4 !w-4 text-background"></tabler-icon>
          <span class="text-xs text-background">{{
            callState.callerInfo.email
          }}</span>
        </div>
        <!-- Phone Number -->
        <div class="flex items-center gap-2">
          <tabler-icon
            name="phone"
            class="!h-4 !w-4 text-background"></tabler-icon>
          <span class="text-xs text-background">{{
            callState.callerInfo.phoneNumber
          }}</span>
        </div>
      </div>
    </div>

    <!-- Error Message -->
    <div
      *ngIf="callState.status === 'error' && callState.error"
      class="mb-3 p-2 bg-red-50 border border-red-200 rounded text-xs text-red-700">
      {{ callState.error }}
    </div>

    <!-- Call Controls -->
    <div class="flex items-center justify-center gap-3">
      <!-- Mute/Unmute Button -->
      <button
        ubButton
        variant="light"
        impact="outline"
        size="md"
        class="w-full"
        (click)="toggleMute()"
        [class.bg-red-100]="callState.isMuted"
        [class.text-red-700]="callState.isMuted">
        <tabler-icon
          [name]="callState.isMuted ? 'microphone-off' : 'microphone'"
          class="!h-5 !w-5 mr-1">
        </tabler-icon>
        {{ callState.isMuted ? 'Unmute' : 'Mute' }}
      </button>

      <!-- Hangup Button -->
      <button
        ubButton
        variant="danger"
        size="md"
        class="w-full"
        (click)="hangup()">
        <tabler-icon name="phone-off" class="!h-5 !w-5 mr-1"></tabler-icon>
        Hang Up
      </button>
    </div>
  </div>
  <div *ngIf="isMinimized" class="bg-foreground rounded-2xl shadow-lg p-2 px-6">
    <div class="flex items-center justify-center">
      <tabler-icon name="phone" class="!h-5 !w-5 text-background"></tabler-icon>
    </div>
  </div>
</div>
